import * as types from "./actionTypes";

export const getRequest = (id) => {
    return {
        type: types.ANNOUNCEMENT_SHOW_REQUEST,
        id
    };
};
export const getSuccess = (id, data) => {
    return {
        type: types.ANNOUNCEMENT_SHOW_SUCCESS,
        payLoad: {id, data}
    };
};
export const getFailure = (id, data) => {
    return {
        type: types.ANNOUNCEMENT_SHOW_FAILURE,
        payLoad: {id, data}
    };
};

export const readRequest = id => {
    return {
        type: types.ANNOUNCEMENT_READ_REQUEST,
        id
    };
};